<template>
  <div class="box4">
    <van-popup v-model="flag" position="bottom" round>
      <div class="check-info-cont">
        <i class="mask-close" @click="closeMask"></i>
        <h2 class="cont-stit">
          {{ leftList[cur].i }}&nbsp;&nbsp;{{ leftList[cur].p }}
        </h2>
        <div class="content-item">
          <div
            class="item"
            v-for="(itemInner, indexInner) in currMaskInfo"
            :key="indexInner"
          >
            <div class="itemContent">
              <span>
                <img src="../../../assets/coursePage/acp/box4/icon02.png" />
                <h1>{{ itemInner.h1 }}</h1>
              </span>
              <p v-html="itemInner.p"></p>
              <i v-show="itemInner.i">项目：{{ itemInner.i }}</i>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <pageTitle
      title="基于阿里云标准深入研发课程<br/>离线平台&实时计算全覆盖"
      titleColor="#332114"
    />
    <div class="text-list-mask">
      <div class="text-list">
        <div
          :class="[cur == index ? 'current' : '']"
          v-for="(item, index) in leftList"
          :key="index"
          @click="changeItem(index)"
        >
          <i>{{ item.i }}</i>
          <p>{{ item.p }}</p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="detail"><a @click="openMask(0)">查看全部</a></div>
      <div
        v-for="(item, index) in rightList"
        v-show="index == cur"
        :key="index"
        class="contentInner"
      >
        <div
          class="item"
          v-for="(itemInner, indexInner) in item"
          :key="indexInner"
        >
          <div class="itemContent">
            <span>
              <img src="../../../assets/coursePage/acp/box4/icon02.png" />
              <h1>{{ itemInner.h1 }}</h1>
            </span>
            <p v-html="itemInner.p"></p>
            <i v-show="itemInner.i">项目：{{ itemInner.i }}</i>
          </div>
        </div>
      </div>
    </div>
    <a class="more" @click="zixun">了解更多</a>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },

  data() {
    return {
      cur: 0,
      flag: false,
      rightList: [
        [
          {
            h1: "阶段一：大数据基础与阿里云平台",
            em: "2天",
            p: `<b>1. 大数据技术概述</b>
               <b>2. 阿里云ACP认证与ACP项目概述</b>
               <b>3. 阿里云平台介绍</b>
               <b>4. 阿里云常见组件说明：</b><em>ECS、RDS、SLB、CDN、OSS</em>`,
            i: "阿里云 ECS项目实战",
          },
          {
            h1: "阶段二：大数据开发与治理平台 DataWorks",
            em: "2-3天",
            p: `<b>1. 阿里云DataWorks产品介绍</b>
                <b>2. Dataworks产品架构及应用场景说明</b>
                <b>3. Dataworks功能介绍：</b><em>数据集成、数据开发、数据治理、运维中心</em>`,
            i: "",
          },
          {
            h1: "阶段三：大数据计算服务 Maxcompute",
            em: "4-5天",
            p: `<b>1. 阿里云MaxCompute产品介绍</b>
                <b>2. MaxCompute产品架构及应用场景说明</b>
                <b>3. MaxCompute 的核心概念及常用开发工具</b>
                <b>4. MaxCompute SQL概述</b>
                <b>5. MaxCompute SQL的常用 DDL、DML操作</b>
                <b>6. MaxCompute SQL中内置函数的使用</b>
                <b>7. MaxCompute SQL自定义函数的分类、开发及使用</b>
                <b>8. MaxCompute SQL性能调优的常用方法</b>
                <b>9. MaxCompute 的权限及安全的管理</b>`,
            i: "Dataworks/MaxCompute项目实战",
          },
          {
            h1: "阶段四：大数据可视化Quick BI 与 DataV",
            em: "1-2天",
            p: `<b>1. 大数据数据可视化概述</b>
            <b>2. 数据分析可视化QuickBI产品介绍</b>
            <b>3. 数据可视化DataV产品介绍</b>
            <b>4. 各种图形绘制操作：</b><em>折线图、柱形图、饼状图、中国地图、运营大屏</em>`,
            i: "QuickBI产品实战-电商仪表板绘制",
          },
        ],
        [
          {
            h1: "阶段一：Flink",
            em: "2天",
            p: `<b>
                1. Flink实时计算简介：</b><em>实时计算概念、应用场景、功能与优势</em><b>
                2. Flink入门：</b><em>环境配置、Flink SQL快速入门、Flink Python 快速入门</em><b>
                3. Flink SQL基础：</b><em>SQL基本概念、时间属性、窗口操作、水印操作、SQL函数</em><b>
                4. Flink CDC：</b><em>Flink CDC简介、功能特性、核心技术</em>`,
            i: "淘宝母婴数据加速查询",
          },
          {
            h1: "阶段二：Hologres",
            em: "1-2天",
            p: `<b>
                1. Hologres 简介：</b><em>Hologres概念、产品优势、应用场景、产品架构、Hologres 功能</em><b>
                2. Hologres快速入门：</b><em>资源领取、入门体验</em><b>
                3. Hologres基本使用</b>`,
            i: "实战：基于 Flink + Hologres 构建实时数仓",
          },
          {
            h1: "阶段三：ElasticSearch",
            em: "1-2天",
            p: `<b>
                1. ElasticSearch简介：</b><em>ElasticSearch概念、应用场景、基本概念</em><b>
                2. 快速入门：</b><em>访问实例、创建索引、插入数据、搜索数据、删除索引</em>`,
            i: "",
          },
        ],
        [
          {
            h1: "阶段一：Data Lake Formation",
            em: "1-2天",
            p: "<b>1. DLF简介：</b><em>什么是DLF</em><b>2. 快速入门</b><b>3. DLF构建MaxCompute湖仓一体</b>",
            i: "",
          },
          {
            h1: "阶段二：机器学习PAI",
            em: "1-2天",
            p: "<b>1. PAI简介：</b><em>功能特性、产品架构、基本概念</em><b>2. 快速入门：</b><em>可视化建模开发、交互式建模开发</em>",
            i: "",
          },
        ],
      ],
      leftList: [
        {
          i: "模块一",
          p: "离线部分",
        },
        {
          i: "模块二",
          p: "实时部分",
        },
        {
          i: "模块三",
          p: "其他部分",
        },
      ],
      list: [
        {
          title: "FineReport模块",
          info: [
            {
              stit: "基础查询",
              text: [
                "· 父子格、参数使用与条件属性运用",
                "· 超级链接、基础图表与函数运用",
                "· 多个功能组合应用实现模拟业务场景",
              ],
            },
            {
              stit: "填报应用",
              text: [
                "· 父子格、参数使用与条件属性运用",
                "· 超级链接、基础图表与函数运用",
                "· 数据填报、JS与权限运用",
                "· 多个功能组合应用实现模拟业务场景",
              ],
            },
            {
              stit: "报表复现",
              text: [
                "· 大屏驾驶舱与移动端报表制作实操",
                "· 图表使用、大屏布局、配色与开发",
                "· 移动端看板布局、配色与开发",
              ],
            },
          ],
        },
        {
          title: "SQL编程语言模块",
          info: [
            {
              stit: "数据库",
              text: ["· 数据库对象的基本概念与作用"],
            },
            {
              stit: "简单查询",
              text: [
                "· 使用 SQL 语句创建、选择、修改、删除、查看数据库对象的操作方法及应用",
              ],
            },
            {
              stit: "复杂查询",
              text: [
                "· 多表连接查询",
                "· 流程控制函数、聚合函数、窗口函数",
                "· 嵌套与子查询",
              ],
            },
          ],
        },
        {
          title: "Kettle数据处理模块",
          info: [
            {
              stit: "",
              text: [
                "· Kettle输入组件、输出组件、转换组件、应用组件实操",
                "· 利用Kettle实现数据抽取、数据转化、数据同步功能",
              ],
            },
          ],
        },
        {
          title: "服务器部署模块",
          info: [
            {
              stit: "",
              text: [
                "· Windows与Linux环境下工程部署",
                "· FineReport数据决策系统管理和使用",
              ],
            },
          ],
        },
      ],
      currMaskInfo: {},
    };
  },
  methods: {
    zixun(name) {
      this.mai("阿里云大数据ACP认证课",'了解更多', 0, null);
      this.clickZiXun()
    },
    changeItem(index) {
      this.cur = index;
    },
    openMask(index) {
      this.currMaskInfo = this.rightList[this.cur];
      this.flag = true;
    },
    closeMask() {
      this.flag = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.box4 {
  padding-top: 79px;
  background: url("../../../assets/coursePage/acp/box4/bg.png") no-repeat;
  background-size: 100% 100%;
  background-position: top center;
  .van-popup {
    max-height: 80%;
    overflow-y: inherit;
    // position: relative;
  }
  .more {
    width: 630px;
    height: 88px;
    background-image: linear-gradient(0deg, #ff8833 0%, #ff6a00 100%);
    border-radius: 44px;
    font-family: PingFang-SC-Bold;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 88px;
    letter-spacing: 1px;
    color: #ffffff;
    text-align: center;
    display: block;
    margin: 60px auto 80px;
  }
  .item {
    display: flex;
    margin-bottom: 46px;

    .itemContent {
      span {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        img {
          width: 54px;
          height: 60px;
          margin-right: 18px;
        }
        h1 {
          font-size: 28px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 38px;
          letter-spacing: 0px;
          color: #332114;
          margin-right: 20px;
        }
        > em {
          height: 24px;
          background-color: #ffede0;
          border-radius: 6px;
          padding: 5px 8px;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #ff6a00;
          font-style: normal;
        }
      }
      p {
        font-family: PingFangSC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 26px;
        letter-spacing: 0px;
        color: #806959;
        ::v-deep {
          b {
            font-family: PingFangSC-Medium;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 36px;
            letter-spacing: 0px;
            color: #4d3f36;
            display: block;
            margin-bottom: 16px;
          }
          > em {
            font-style: normal;
            display: block;
            padding-left: 24px;
            margin-bottom: 24px;
            line-height: 36px;
          }
        }
      }
      i {
        font-family: PingFang-SC-Bold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #ff7f00;
        margin-top: 10px;
        font-style: normal;
        display: block;
      }
    }
  }

  .check-info-cont {
    width: 100%;
    box-sizing: border-box;
    padding: 48px 0px 48px 48px;
    position: relative;
    height: 100%;
    .content-item {
      height: 800px;
      overflow-y: auto;
    }
    .mask-close {
      position: absolute;
      top: 48px;
      right: 48px;
      width: 32px;
      height: 32px;
      background-image: url(../../../assets/coursePage/fcp/box5/icon-close.png);
      background-size: 100% 100%;
    }
    .cont-stit {
      font-family: PingFangSC-Medium;
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 38px;
      letter-spacing: 0px;
      color: #33210f;
      padding-bottom: 30px;
    }
    .cont-list {
      li {
        margin-top: 32px;
        h4 {
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #4e5969;
          line-height: 44px;
          text-shadow: 0px 4px 40px rgba(0, 0, 0, 0.08);
          margin-bottom: 16px;
        }
        p {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 44px;
          text-shadow: 0px 4px 40px rgba(0, 0, 0, 0.08);
        }
      }
    }
  }

  .previewImage {
    position: fixed;
    top: 0px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 200;
    img {
      width: 100%;
    }
  }
  .content {
    padding: 0 32px;
    max-height: 712px;
    position: relative;
    overflow: hidden;
    .detail {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
      /* 从上到下的水平渐变 */
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        #fff,
        #fff,
        #fff
      );
      a {
        width: 180px;
        height: 60px;
        line-height: 60px;
        background-image: linear-gradient(90deg, #ff7f00 0%, #ff6a00 100%);
        border-radius: 30px;
        font-family: PingFang-SC-Bold;
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        text-align: center;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }
    .contentInner {
      background-color: #ffffff;
      box-shadow: 0px 10px 20px 0px #ffd9b2;
      border-radius: 30px;
      width: 100%;
      padding: 40px 30px;
      box-sizing: border-box;
    }
  }
  .stit-2 {
    margin-top: 80px;
    &:after {
      width: 228px;
    }
  }
  .text-list-mask {
    margin-top: 48px;
    overflow-x: auto;
    overflow-y: hidden;
    height: 136px;

    width: 100%;
    .text-list {
      max-width: 100%;
      height: 176px;
      display: flex;
      padding: 0 32px 40px;
      overflow-x: auto;
      overflow-y: hidden;
      box-sizing: border-box;
      > div {
        width: 260px;
        min-width: 260px;
        height: 76px;
        background-color: #ffffff;
        box-shadow: 0px 10px 20px 0px #ffd9b2;
        border-radius: 14px;
        margin-right: 30px;
        font-family: PingFangSC-Medium;
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        text-align: center;
        line-height: 76px;
        letter-spacing: 0px;
        color: #33210f;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        i {
          margin-right: 6px;
        }
        &:last-child {
          margin: 0;
        }
      }
      > div.current {
        background-color: #ff6a00;
        box-shadow: 0px 10px 20px 0px #ffd9b2;
        color: #ffffff;
      }
    }
  }
}
</style>